import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';

export const HOME_GUIDEBOOKS_ANCHOR = 'guidebooks';

export function useHomeGuidebooksPath() {
  const {getFullPath} = usePath();
  return `${getFullPath(PATHS.home)}#${HOME_GUIDEBOOKS_ANCHOR}`;
}
